<div class="select-filter-container">
  <div class="container-input">
    <h4>{{label}}</h4>
    <input
      type="text"
      [(ngModel)]="searchTerm"
      (input)="onInputChange()"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      placeholder="Digite para filtrar as opções"
    />
    <button type="button" title="Limpar" (click)="clearInput()" *ngIf="this.searchTerm.length > 0">
      <i class="material-icons">close</i>
    </button>
  </div>

  <ul *ngIf="showDropdown && filteredOptions.length > 0" class="dropdown">
    <li
      *ngFor="let option of filteredOptions"
      (mousedown)="selectItem(option)"
    >
      {{ option.nome }}
    </li>
  </ul>
</div>
